import React from 'react';

import { Button, Paper, ScrollArea, useMantineTheme } from '@mantine/core';
import { PackageCategoryAutoComplete } from 'types';

interface IPackageCategoryFilterProps {
  categories: PackageCategoryAutoComplete[];
  packageCategory: PackageCategoryAutoComplete | null;
  setPackageCategory: (category: PackageCategoryAutoComplete | null) => void;
}

const PackageCategoryFilter = ({
  categories,
  packageCategory,
  setPackageCategory,
}: IPackageCategoryFilterProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Paper withBorder radius='md' p={0} bg={theme.colors.gray[1]}>
      <ScrollArea type='auto' scrollbarSize={6} p='xs'>
        <div style={{ display: 'inline-flex', gap: theme.spacing.sm }}>
          <Button
            variant={packageCategory === null ? 'filled' : 'outline'}
            color={packageCategory === null ? 'kiloBlue' : 'gray'}
            bg={packageCategory === null ? 'undefined' : 'white'}
            onClick={() => setPackageCategory(null)}
          >
            All
          </Button>

          {categories.map(category => (
            <Button
              key={category.packageCategoryId}
              variant={
                packageCategory?.packageCategoryId === category.packageCategoryId ? 'filled' : 'outline'
              }
              color={packageCategory?.packageCategoryId === category.packageCategoryId ? 'kiloBlue' : 'gray'}
              bg={packageCategory?.packageCategoryId === category.packageCategoryId ? 'undefined' : 'white'}
              onClick={() => setPackageCategory(category)}
            >
              {category.name}
            </Button>
          ))}
        </div>
      </ScrollArea>
    </Paper>
  );
};

export default PackageCategoryFilter;
